// import Vue from 'vue'

// import Loader from '@/components/Loader'
import Render from '@/components/Render'
import DatePicker from '@/components/ui/DatePicker'
import TextBox from '@/components/ui/TextBox'
import Textarea from '@/components/ui/Textarea'
import SelectBox from '@/components/ui/SelectBox'
import CheckBox from '@/components/ui/CheckBox'
import vSelect from 'vue-select'
// import LookUp from '@/components/ui/LookUp'

// const loadingInstance = new Vue({
//   data: {
//     show: false,
//     class: ''
//   }
// })

export default {
  install (Vue) {
    // Vue.prototype.$loading = loadingInstance
    // Vue.component('Loader', Loader)
    Vue.component('Render', Render)
    Vue.component('DatePicker', DatePicker)
    Vue.component('TextBox', TextBox)
    Vue.component('Textarea', Textarea)
    Vue.component('LookUp', vSelect)
    Vue.component('SelectBox', SelectBox)
    Vue.component('CheckBox', CheckBox)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/core-components.js